module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.516070a4.png";